import { render, staticRenderFns } from "./QuestionAboutWhiteReplace.vue?vue&type=template&id=0e673836&scoped=true"
import script from "./QuestionAboutWhiteReplace.vue?vue&type=script&lang=ts"
export * from "./QuestionAboutWhiteReplace.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./QuestionAboutWhiteReplace.vue?vue&type=style&index=0&id=0e673836&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./QuestionAboutWhiteReplace.vue?vue&type=style&index=1&id=0e673836&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0e673836",
  null
  ,true
)

export default component.exports